<template>
  <div class="active-window">
    <image-modal
      v-if="imageModalShow"
      :link="imageLink"
      @close="imageModalShow = false"
    />
    <div
      class="ticket-details"
      v-if="!loading"
      :class="{ expanded: isTicketInfoExpanded }"
    >
      <div class="info">
        <div class="column basic">
          <div class="user-info">
            <basic-info
              :profilePictureURL="
                baseURL + ticketDetails.author.user_profile_pic.link
              "
              :name="ticketDetails.author.user_full_name"
              :description="ticketDetails.author.div_description"
            />
          </div>
          <div class="dates">
            <div class="single-date">
              <b>Tiket postavljen</b>
              <span>{{
                ticketDetails.timestamp | formatDateTimeNoSeconds
              }}</span>
            </div>
            <div class="single-date">
              <b>Poslednja izmena</b>
              <span>{{
                ticketDetails.last_edit | formatDateTimeNoSeconds
              }}</span>
            </div>
            <div class="single-date" v-if="ticketDetails.closed">
              <b>Tiket zatvorio</b>
              <span
                >{{ ticketDetails.whoClosed }} nakon
                {{ ticketDetails.log }}</span
              >
            </div>
          </div>
        </div>
        <div class="column right">
          <div class="badges">
            <div>
              <div style="display: flex">
                <status-bar
                  v-if="ticketDetails.projectId"
                  :status="'Projekat'"
                  class="statbar"
                ></status-bar>
                <status-bar
                  v-if="ticketDetails.privacy === '1'"
                  status="Privatan"
                  class="statbar"
                ></status-bar>
                <status-bar
                  :status="ticketDetails.current_status"
                  class="statbar"
                ></status-bar>
                <status-bar
                  :status="ticketDetails.priority_id"
                  class="statbar"
                ></status-bar>
              </div>
              <div class="ticket-actions">
                <button
                  @click="openModalContractorEmail"
                  class="btn btn-primary btn--mod btn--mail"
                  v-if="ticketDetails.contractor"
                >
                  <i class="fas fa-envelope" style="margin-right: 4px"></i>
                  Pošalji mail serviseru
                </button>
                <button
                  @click="openProject"
                  class="btn btn-primary btn--mod"
                  v-if="ticketDetails.projectId"
                >
                  <i
                    class="fas fa-clipboard-list"
                    style="margin-right: 4px"
                  ></i>
                  Idi na projekat
                </button>
              </div>
            </div>
            <div>
              <i class="fas fa-pen" @click="openModal"></i>
              <button
                @click="toggleTicketInfo"
                class="btn btn-medium btn--mod"
                v-if="
                  ticketDetails.media.length !== 0 ||
                    ticketDetails.description.length > 200
                "
              >
                <i
                  v-if="!isTicketInfoExpanded"
                  class="fa fa-expand"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="isTicketInfoExpanded"
                  class="fa fa-compress"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
          <div class="description ">
            <b>Detalji tiketa</b>
            <p v-if="isTicketInfoExpanded">
              {{ ticketDetails.description }}
              <!-- <br /> -->
            </p>
            <p v-if="!isTicketInfoExpanded" class="shoten-text" ref="desc">
              {{ ticketDetails.description }}
            </p>
            <!-- <br /> -->
          </div>

          <div class="description ">
            <b>Datum nastanka</b>
            <p>{{ ticketDetails.ticketDate | formatDateTimeNoSeconds }}</p>
          </div>

          <div class="extra-info description">
            <div v-if="ticketDetails.community_infrastructure">
              <b
                >Infrasturktura
                <a
                  class=" details-icon"
                  :href="
                    '#/community/' +
                      communityId +
                      '/infrastructure/' +
                      ticketDetails.community_infrastructure.id
                  "
                >
                  <i
                    class="fas fa-info-circle"
                    title="Idi na detalje infrastrukture"
                  ></i>
                </a>
              </b>
              <p>{{ ticketDetails.community_infrastructure.name }}</p>
            </div>
            <div class="contractor">
              <div v-if="ticketDetails.contractor" class="contractor-details">
                <b
                  >Serviser
                  <a
                    class=" details-icon"
                    :href="'/#/contractor/' + ticketDetails.contractor.id"
                  >
                    <i
                      class="fas fa-info-circle"
                      title="Idi na detalje servisera"
                    ></i> </a
                ></b>
                <p>{{ ticketDetails.contractor.name }}</p>
              </div>
              <div class="contractor-contact" v-if="ticketDetails.contact">
                <b> Kontakt</b>
                <p>
                  <a class="">
                    <i class="fas fa-user"></i>
                  </a>
                  {{ ticketDetails.contact.name }}
                </p>
                <p>
                  <a class="">
                    <i class="fas fa-phone"></i>
                  </a>
                  {{
                    ticketDetails.contact.phone
                      ? ticketDetails.contact.phone
                      : '/'
                  }}
                </p>
                <p v-if="ticketDetails.contact.email">
                  <a class="">
                    <i class="fas fa-envelope"></i>
                  </a>
                  {{ ticketDetails.contact.email }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="files-info"
            v-if="!isTicketInfoExpanded && ticketDetails.media.length !== 0"
            @click="toggleTicketInfo"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            <span>
              {{ ticketDetails.media.length }}
              {{
                ticketDetails.media.length === 1
                  ? 'fajl'
                  : ticketDetails.media.length > 4
                  ? 'fajlova'
                  : 'fajla'
              }}
            </span>
          </div>
          <div
            class="files-area"
            v-if="isTicketInfoExpanded && ticketDetails.media.length !== 0"
          >
            <div class="images-wrapper">
              <a
                v-for="i in imageFiles"
                :key="i.link"
                @click="openImagePreview(baseURL + i.link)"
              >
                <img :src="baseURL + i.link_to_thumb" />
              </a>
            </div>
            <a
              class="file"
              v-for="f in otherFiles"
              :key="f.link"
              :href="baseURL + f.link"
              target="_blank"
            >
              <p>{{ f.file_name }}</p>
              <a>
                <i class="fas fa-file-download"></i>
              </a>
            </a>
          </div>
          <a
            v-if="
              (ticketDetails.media.length !== 0 ||
                ticketDetails.description.length > 200) &&
                !isTicketInfoExpanded
            "
            @click="toggleTicketInfo"
            class="show-more-info"
            >Proširi pregled</a
          >
          <a
            v-if="
              (ticketDetails.media.length !== 0 ||
                ticketDetails.description.length > 200) &&
                isTicketInfoExpanded
            "
            @click="toggleTicketInfo"
            class="show-more-info"
            >Smanji pregled</a
          >
        </div>
      </div>
      <div id="comments-area">
        <div
          id="comments"
          ref="comments"
          :class="{ expanded: isTicketInfoExpanded }"
        >
          <div class="no-comments" v-if="getCommentsNumber === 0">
            <p>Trenutno nema komentara</p>
          </div>
          <comment
            v-for="c in comments"
            :comment="c.data"
            :type="c.type"
            :key="c.id"
          ></comment>
        </div>
        <div class="comment-wrapper">
          <div class="above-comment-section">
            <p class="uploaded-file" v-if="attachmentName">
              {{ attachmentName }}
              <span class="btn btn-primary" @click="clearAttachInput">
                <i class="fas fa-times"></i>
              </span>
            </p>
            <div class="wrapper-send-to-contractor">
              <div
                class="send-to-contractor"
                v-if="
                  ticketDetails.contractor &&
                    comment.length > 0 &&
                    ticketDetails.isForwardedToContractor
                "
              >
                Prosledi serviseru na email
                <checkbox
                  class="ticket-cb"
                  :checked="sendToContractor"
                  @change="sendToContractor = !sendToContractor"
                ></checkbox>
              </div>
            </div>
          </div>
          <div id="new-comment-section">
            <div id="upload-area">
              <div
                id="add-img-wrapper"
                @click="uploadFileClicked"
                v-if="!commentUploadUrl"
              >
                <i class="fas fa-paperclip"></i>
              </div>
              <div id="attached-img-wrapper" v-if="commentUploadUrl">
                <div class="hover-shadow" @click="clearAttachInput">
                  <i class="far fa-trash-alt"></i>
                </div>
                <img
                  :src="commentUploadUrl"
                  id="comment-upload-pic"
                  alt="slika"
                />
              </div>
            </div>
            <div class="textarea-wrapper">
              <textarea
                @keydown.enter="handleOnEnter"
                class="form-control"
                :class="{ 'textarea-error': comment.length > 300 }"
                rows="1"
                placeholder="Unesite komentar"
                v-model="comment"
                ref="messageTextArea"
                :style="{ height: messageTextAreaHeight + 'px' }"
                @input="autoresizeTextarea"
              ></textarea>
              <div
                class="character-counter"
                :class="{ 'character-counter-error': comment.length > 300 }"
              >
                {{ comment.length }}/300
              </div>
            </div>
            <div id="new-comment-control">
              <input
                @change="fileAttached"
                ref="commentUpload"
                type="file"
                style="display:none"
              />
              <button
                :disabled="comment.length === 0 || commentSending"
                class="btn btn-primary btn--mod"
                @click="submitComment"
              >
                <slot>
                  <spinner
                    :size="20"
                    line-fg-color="#00796b"
                    v-if="commentSending"
                  />
                </slot>
                <slot v-if="!commentSending">
                  Pošalji
                  <!-- <i class="fas fa-paper-plane"></i> -->
                </slot>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner
      spinner
      class="spinner"
      line-fg-color="#00796b"
      :size="100"
      :line-size="6"
      v-if="loading"
    ></spinner>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import TicketStatusBadge from '@/components/common/TicketStatusBadge.vue';
import BasicInfo from '@/components/common/BasicInfo.vue';
import TicketComment from '@/components/common/TicketComment.vue';
import axios from '@/axios/axios.js';
import { formatDateNoSecondsMixin } from '@/mixins/mixins.js';
import ImageModal from '@/components/modal/ModalImage.vue';
import checkbox from '@/components/common/Checkbox';

export default {
  name: 'Ticket',
  components: {
    'status-bar': TicketStatusBadge,
    comment: TicketComment,
    basicInfo: BasicInfo,
    ImageModal,
    checkbox
  },
  mixins: [formatDateNoSecondsMixin],
  data() {
    return {
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      comment: '',
      commentSending: false,
      commentUploadUrl: '',
      commentUploadFile: null,
      isTicketInfoExpanded: false,
      messageTextAreaHeight: 40,
      imageModalShow: false,
      imageLink: '',
      communityId: this.$store.getters.getActiveCommunity.id,
      attachmentName: null,
      sendToContractor: false
    };
  },
  computed: {
    ...mapState('ticket', [
      'ticketDetails',
      'comments',
      'userPicUrl',
      'basicInfo'
    ]),
    ...mapState(['loading']),
    getCommentsNumber() {
      if (this.comments == null || this.comments.length === 0) {
        return 0;
      } else {
        return 1;
      }
    },
    imageFiles() {
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.ticketDetails.media.filter(
        el => imageTypes.indexOf(el.type) > -1
      );
    },
    otherFiles() {
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.ticketDetails.media.filter(
        el => imageTypes.indexOf(el.type) === -1
      );
    }
  },
  created() {
    this.getTicketDetails();
  },
  destroyed() {
    this.clearTicketModule();
  },
  methods: {
    ...mapActions('ticket', ['getTicketDetails', 'getTicketComments']),
    ...mapMutations('ticket', ['clearTicketModule']),
    ...mapMutations('modal', [
      'setTicket',
      'showModal',
      'setContractorContact'
    ]),
    ...mapActions('modal', ['showFailModal']),
    clearAttachInput() {
      this.$refs.commentUpload.value = '';
      this.commentUploadUrl = '';
      this.commentUploadFile = null;
      this.attachmentName = null;
    },
    uploadFileClicked() {
      if (!this.attachmentName) {
        this.$refs.commentUpload.click();
      }
    },
    handleOnEnter(e) {
      if (this.commentSending) {
        return;
      }
      if (e.ctrlKey) {
        this.submitComment();
      }
    },
    openImagePreview(link) {
      this.imageLink = link;
      this.imageModalShow = true;
    },
    calcHeight(value) {
      let numberOfLineBreaks = (value.match(/\n/g) || []).length;
      // min-height + lines x line-height + padding + border
      let newHeight = 20 + numberOfLineBreaks * 20 + 12 + 2;
      return newHeight;
    },
    autoresizeTextarea(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
      if (event.target.scrollHeight > 110) {
        event.target.style.height = '110px';
      }
    },
    toggleTicketInfo() {
      this.isTicketInfoExpanded = !this.isTicketInfoExpanded;
    },
    fileAttached(event) {
      // validate file size
      if (event.target.files[0].size > 5122059) {
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      // check if attachment is image
      if (this.validateInput(event.target.value)) {
        this.commentUploadUrl = URL.createObjectURL(event.target.files[0]);
      } else {
        this.attachmentName = event.target.files[0].name;
      }
      this.commentUploadFile = event.target.files[0];
    },
    validateInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('.') + 1, value.length);
      return allowedExtensions.indexOf(extension) > -1;
    },
    submitComment() {
      if (this.comment.trim().length > 300) {
        this.showFailModal('Komentar može imati najviše 300 karaktera.');
        return;
      }
      this.commentSending = true;
      if (this.commentUploadFile != null) {
        axios
          .post('media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({ data }) => {
            axios
              .post(`tickets/${this.basicInfo.ticketId}/comments`, {
                comment_body: this.comment.trim(),
                member_id: this.$store.getters.getActiveCommunity.member_id,
                media_id: data.ids[0],
                forwardReply: this.sendToContractor
              })
              .then(async res => {
                this.commentSending = false;
                await this.getTicketComments();
                this.resetInputFields();
              })
              .catch(e => {
                this.commentSending = false;
                this.showFailModal();
                console.log(e);
              });
          })
          .catch(error => {
            this.commentSending = false;
            this.showFailModal();
          });
      } else {
        axios
          .post(`tickets/${this.basicInfo.ticketId}/comments`, {
            comment_body: this.comment.trim(),
            member_id: this.$store.getters.getActiveCommunity.member_id,
            forwardReply: this.sendToContractor
          })
          .then(async res => {
            this.commentSending = false;
            await this.getTicketComments();
            this.resetInputFields();
          })
          .catch(e => {
            this.commentSending = false;
            console.log(e);
          });
      }
    },
    resetInputFields() {
      this.comment = '';
      this.messageTextAreaHeight = 40;
      this.clearAttachInput();
    },
    formatMediaForSubmit() {
      if (this.commentUploadFile != null) {
        let fd = new FormData();
        fd.append(
          'files[]',
          this.commentUploadFile,
          this.commentUploadFile.name
        );
        fd.append('type', 'community');
        fd.append('community_id', this.ticketDetails.community_id);

        return fd;
      }
      return null;
    },
    openModal() {
      this.setTicket(this.ticketDetails);
      this.showModal('ModalContentTicketEdit');
    },
    openModalContractorEmail() {
      this.setTicket(this.ticketDetails);
      this.showModal('ModalContentSendContractorEmail');
    },
    openProject() {
      this.$router.push({
        name: 'projectDetails',
        params: {
          projectId: this.ticketDetails.projectId
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.ticket-actions {
  margin-top: 8px;
  button {
    margin-left: 0 !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .btn--mail {
    margin-right: 8px;
  }
}
.fa-pen {
  cursor: pointer;
  color: var(--primary-color);
  margin-right: 8px;
}
.above-comment-section {
  display: flex;
  justify-content: space-between;
  .wrapper-send-to-contractor {
    align-items: flex-end;
    display: flex;
    margin-left: auto;

    .send-to-contractor {
      // padding-right: 20px !important;
      // margin-left: 65%;
      // width: 35%;
      // position: absolute;
      // bottom: 55px;
      display: flex;
      align-items: end;
      justify-content: flex-end;
      text-align: right;
      label {
        margin-left: 8px;
      }
      .cb-container {
        padding-left: 25px !important;
      }
    }
  }

  .uploaded-file {
    max-width: 60%;
    // position: absolute;
    // bottom: 55px;
    background: var(--primary-color);
    border-radius: 4px 4px 0 0;
    padding: 0px 8px;
    color: white;
    text-align: left;
    margin-left: 45px !important;
    span {
      padding-right: 0;
    }
  }
}
.shoten-text {
  overflow: hidden !important;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.active-window {
  // height: calc(100% - 120px);
  height: calc(100vh - 104px);
}
.character-counter {
  right: 105px;
}
.ticket-details {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100%;
  /*min-width: 450px;*/
  padding: 10px;
  .contractor {
    display: flex;
    .contractor-details {
      flex: 2;
    }
    .contractor-contact {
      margin-left: 40px;
      flex: 1;
      a {
        margin-right: 4px;
      }
    }
  }
  .details-icon {
    color: var(--primary-color);
  }
  &.expanded {
    height: unset;
  }
  hr {
    margin-left: 0;
    margin-right: 0;
  }
  .info {
    flex: 20%;
    position: relative;
    border: 1px solid gray;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    .column {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &.basic {
        .user-info {
          display: flex;
          padding-right: 6px;
        }
        .dates {
          display: flex;
          flex-direction: column;
          text-align: left;
          margin: 0;
          margin-top: 20px;
          .single-date {
            // margin-top: 2px;
            display: flex;
            flex-direction: column;
            span {
              margin-top: -4px;
            }
          }
        }
      }
      &.right {
        // border: 1px solid red;
        flex: 3;
        justify-content: flex-start;
        .badges {
          // width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 15px;
          // margin-top: 5px;
          .statbar {
            margin-right: 3px;
          }
        }
        .description {
          padding: 3px 5px;
          // background-color: #fabb4738;
          /* border: 1px solid #000000; */
          border-radius: 3px;
          p {
            // max-height: 120px;
            overflow: auto;
            margin-top: 4px !important;
            word-break: break-all;
          }
        }
        .files-info {
          border: 1px solid gray;
          border-radius: 6px;
          // width: 140px;
          width: fit-content;
          padding: 4px 8px;
          // padding-left: 10px;
          font-weight: 600;
          display: inline-flex;
          justify-content: center;
          cursor: pointer;
          i {
            font-size: 22px;
            margin-right: 8px;
          }
          &:hover {
            background: rgba(108, 108, 108, 0.05);
          }
        }
        .files-area {
          margin-top: 10px;
          width: 100%;
          text-align: left;
          // max-height: 86px;
          justify-content: space-between;
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          resize: none;

          .images-wrapper {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 12px;
            img {
              width: 100px;
              height: 100px;
              object-fit: cover;
              margin-right: 12px;
              border-radius: 6px;
              &:hover {
                opacity: 0.7;
                cursor: pointer;
              }
            }
          }

          .file {
            display: flex;
            align-items: center;
            // flex-shrink: 0;
            flex: 0 0 49%;
            max-width: 49%;
            background-color: #d5d5d54a;
            margin-bottom: 6px;
            margin-right: 6px;
            height: auto;
            // margin: 4px;
            border-radius: 4px;
            color: black;

            p {
              // word-break: break-word;
              margin-bottom: 0;
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              // direction: rtl;
              padding: 4px;
            }

            i {
              color: var(--primary-color);
              float: right;
              margin: 0 15px;
            }
          }
        }
      }
    }
    .btn--mod {
      // position: absolute;
      // right: 10px;
      // top: 10px;
      flex: 0 0 0;
      // margin-left: auto;
      margin-left: 12px;
      padding: 3px;
      vertical-align: middle;
      height: 35px;
      min-width: 75px;
    }
    .show-more-info {
      margin-top: 8px;
      color: var(--primary-color);
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  #comments-area {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    justify-content: space-between;
    flex: 100;
    #comments {
      overflow: auto;
      padding-right: 10px;
      &.expanded {
        max-height: 54vh;
        min-height: 20vh;
      }
    }
    #new-comment-section {
      margin-top: 5px;
      height: auto;
      display: inline-flex;
      align-items: flex-end;
      width: 100%;
      textarea {
        resize: none;
      }

      #upload-area {
        // min-width: 40px;
        // max-width: 40px;
        height: 40px;
        width: 45px;
        margin-right: 5px;
        background-color: rgba(211, 211, 211, 0.37);
        border-radius: 5px;
        overflow: hidden;

        #attached-img-wrapper {
          .hover-shadow {
            border-radius: 5px;
            opacity: 0;
            min-width: 40px;
            min-height: 40px;
            background-color: rgba(0, 0, 0, 0.41);
            position: absolute;
            transition: opacity 0.2s;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              color: white;
            }
          }
        }

        #attached-img-wrapper:hover {
          .hover-shadow {
            opacity: 1;
          }
        }

        #add-img-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fa-paperclip {
          transition: color 0.25s;
          font-size: 25px;
        }

        img {
          width: 40px;
          height: 40px;
          object-fit: scale-down;
        }
      }

      #upload-area:hover {
        cursor: pointer;
        .fa-paperclip {
          color: var(--primary-color);
        }
      }

      #new-comment-control {
        display: flex;
        float: right;
        align-items: flex-end;

        button {
          margin-left: 5px;
          height: 40px;
          // width: 40px;
          i {
            font-size: 35px;
          }
        }

        #comment-upload-btn {
          margin-right: 5px;
          font-size: 20px;
        }
      }
    }
  }
}

.hidden {
  display: flex;
  display: none;

  .ticket-info {
    display: flex;
    position: relative;
    width: 30%;
    min-width: 300px;
    flex-grow: 1;
    flex-shrink: 4;
    flex-direction: column;
  }

  .description {
    text-align: center;
    margin-bottom: 40px;
    h5 {
      display: inline-block;
      padding-bottom: 5px;
      border-bottom: 2px solid var(--primary-color);
    }
  }

  .user-info {
    display: flex;
  }

  .basic-info {
    padding-left: 10px;
    text-align: start;
    h5 {
      color: var(--primary-color);
      font-weight: bold;
    }
  }

  .badges {
    display: flex;
    align-content: flex-start;
    margin-bottom: 15px;
    margin-top: 5px;
    .statbar {
      margin-right: 3px;
    }
  }

  .no-comments {
    text-align: center;
    margin-top: 30px;
  }

  .uploaded-content {
    margin: 5px 10px 0 10px;
    width: 150px;
    height: auto;
    object-fit: scale-down;
    border-radius: 5px;
  }

  .border {
    margin: 0 10px;
  }

  .btn--mod {
    flex: 0 0 0;
    margin-left: auto;
    padding: 3px;
    vertical-align: middle;
    height: 35px;
    min-width: 75px;
  }

  #comments-area {
    flex-shrink: 1;
    flex-grow: 4;
    width: 50%;
    margin: 0 15px;
  }

  .ticket-section {
    display: flex;
    position: relative;
  }

  #comments {
    overflow-y: auto;
    height: calc(100% - 200px);
    padding: 0 15px;
    border-left: 1px solid rgba(108, 108, 108, 0.55);
    border-right: 1px solid rgba(108, 108, 108, 0.55);
  }

  .ticket-header {
    padding: 10px;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 5px 5px 0 5px;
  }

  .files-area {
    width: 100%;
    text-align: left;
    max-height: 60%;
    justify-content: space-between;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    resize: none;
  }

  .file {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    background-color: #d5d5d54a;
    margin-bottom: 1px;
    height: auto;

    p {
      word-break: break-word;
      margin-bottom: 0;
      width: 100%;
    }

    i {
      color: var(--primary-color);
      float: right;
      margin: 0 15px;
    }
  }

  .content-area {
    display: flex;
    flex-shrink: 4;
    flex-grow: 1;
    width: 30%;
    flex-direction: column;
    text-align: justify;
  }

  .dates {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 25px;
    p {
      margin-bottom: 5px;
    }
  }

  .spinner {
    margin-top: 100px;
  }

  .profile-pic {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
    overflow: hidden;
  }

  #new-comment-section {
    margin-top: 15px;
    height: auto;
    display: inline-flex;
    width: 100%;
    textarea {
      resize: none;
    }

    #upload-area {
      min-width: 85px;
      max-width: 85px;
      margin-right: 5px;
      background-color: rgba(211, 211, 211, 0.37);
      border-radius: 5px;
      overflow: hidden;

      #attached-img-wrapper {
        .hover-shadow {
          border-radius: 5px;
          opacity: 0;
          min-width: 85px;
          min-height: 85px;
          background-color: rgba(0, 0, 0, 0.41);
          position: absolute;
          transition: opacity 0.2s;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: white;
          }
        }
      }

      #attached-img-wrapper:hover {
        .hover-shadow {
          opacity: 1;
        }
      }

      #add-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .fa-paperclip {
        transition: color 0.25s;
        font-size: 25px;
      }

      img {
        width: 85px;
        height: 85px;
        object-fit: cover;
      }
    }

    #upload-area:hover {
      cursor: pointer;
      .fa-paperclip {
        color: var(--primary-color);
      }
    }

    #new-comment-control {
      display: flex;
      float: right;
      align-items: center;

      button {
        margin-left: 5px;
      }

      #comment-upload-btn {
        margin-right: 5px;
        font-size: 20px;
      }
    }
  }
}
</style>
